export default __webpack_public_path__ + "static/media/Portfolio.293e0284.svg";